import { Image } from '@arco-design/web-react';
import { IconAttachment } from '@arco-design/web-react/icon';

import './PostAttachments.css';


interface PostAttachmentsProps {
  document_url?: string;
  file_name?: string;
  images?: string[];
}

export const PostAttachments = ({  document_url, file_name, images, }: PostAttachmentsProps) => {
  return (
    <div className="post-attachments__wrapper">
      {document_url && (
        <div className='file-preview link' onClick={() => window.open(document_url, '_blank')}>
          <IconAttachment />
          <span>{file_name}</span>
        </div>
      )}

      {images && images.length > 0 && <div className="image-with-previews">
        {images.map((image_url, index) => (
          image_url && <div key={index} className="image-with-preview">
            <Image
              className="image-with-preview__image"
              src={image_url}
              alt={`Preview ${index}`}
            />
          </div>
        ))}

      </div>}
    </div>
  )
}
